import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

const EDGE_FN_URL = `https://${import.meta.env.VITE_SUPABASE_PROJECT_ID}.supabase.co/functions/v1/lite`;

export default function LiteRedirect() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const qs = searchParams.toString();
    window.location.replace(qs ? `${EDGE_FN_URL}?${qs}` : EDGE_FN_URL);
  }, [searchParams]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <p className="text-muted-foreground">Videresender til Flyt Lite…</p>
    </div>
  );
}
